export enum AccessPointProcessingOperation {
  Append = "Append",
  Query = "Query",
  Filter = "Filter",
  Transform = "Transform",
  Validate = "Validate",
}
